import { Controller } from "@hotwired/stimulus";
import { useClickOutside } from "stimulus-use";

export default class extends Controller {
  static outlets = ["collapsible"];

  static values = {
    collapseWith: { type: String, default: "hidden" },
    expandWith: { type: String, default: "" },
  };

  connect() {
    useClickOutside(this);
  }

  clickOutside() {
    if (this.hasCollapsibleOutlet) {
      this.collapsibleOutlet.collapse();
    } else {
      this.collapse();
    }
  }

  expand() {
    this.collapsesWith.forEach((className) => {
      this.element.classList.remove(className);
    });
    this.expandsWith.forEach((className) => {
      this.element.classList.add(className);
    });
    this.element.setAttribute("aria-expanded", true);
  }

  collapse() {
    this.collapsesWith.forEach((className) => {
      this.element.classList.add(className);
    });
    this.expandsWith.forEach((className) => {
      this.element.classList.remove(className);
    });
    this.element.setAttribute("aria-expanded", false);
  }

  toggle() {
    if (this.element.getAttribute("aria-expanded") == "true") {
      this.collapse();
    } else {
      this.expand();
    }
  }

  get collapsesWith() {
    return this.collapseWithValue.split(" ");
  }

  get expandsWith() {
    return this.expandWithValue.split(" ");
  }
}
